import { render, staticRenderFns } from "./yearSpec.vue?vue&type=template&id=d1360a7c&scoped=true&"
import script from "./yearSpec.vue?vue&type=script&lang=ts&"
export * from "./yearSpec.vue?vue&type=script&lang=ts&"
import style0 from "./yearSpec.vue?vue&type=style&index=0&id=d1360a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1360a7c",
  null
  
)

export default component.exports